import { useState } from 'react';
import { Save, UserPlus } from 'lucide-react';
import { Button, SettingToggleCard } from '@/design-system';
import { useAuth } from '@/core/auth';
import { usePlatformSettings } from '../../hooks/usePlatformSettings';

export function PlatformSettingsSection() {
  const { query, save } = usePlatformSettings();
  const { user } = useAuth();
  const [draft, setDraft] = useState<boolean | null>(null);
  const canEdit = user?.role === 'SUPERADMIN';
  const enabled = draft ?? query.data?.selfServeSignupEnabled ?? false;
  if (query.isPending) return <p role="status" className="text-sm text-gray-500">Carregando configurações…</p>;
  if (!query.data) return <div role="alert" className="space-y-3 text-sm text-red-700">
    Não foi possível carregar as configurações da plataforma.
    <Button variant="subtle" onClick={() => void query.refetch()}>Tentar novamente</Button>
  </div>;
  return <div className="space-y-5">
    {query.isError && <p role="alert" className="text-sm text-red-700">Não foi possível atualizar as configurações. Os dados anteriores foram preservados.</p>}
    <SettingToggleCard title="Permitir auto-cadastro de tenants" icon={UserPlus}
      description="Quando desativado, o cadastro público fica bloqueado. Novas empresas devem ser cadastradas pelo Manager."
      checked={enabled} disabled={!canEdit || save.isPending} onChange={(value) => { setDraft(value); save.reset(); }} />
    {save.isError && <p role="alert" className="text-sm text-red-700">Não foi possível salvar as configurações. Tente novamente.</p>}
    {save.isSuccess && <p role="status" className="text-sm text-emerald-700">Configurações salvas.</p>}
    {!canEdit && <p className="text-xs text-gray-500">Somente administradores da plataforma podem alterar estas configurações.</p>}
    <div className="flex justify-end">
      <Button disabled={!canEdit || enabled === query.data.selfServeSignupEnabled} isLoading={save.isPending}
        onClick={() => save.mutate(enabled, { onSuccess: () => setDraft(null) })}><Save size={16} />Salvar alterações</Button>
    </div>
  </div>;
}
